export default __webpack_public_path__ + "static/media/LaboratoryCalibration.4f14f440.PNG";